import React from 'react';
import styles from './EmptyState.module.scss';

interface EmptyStateProps {
    title: string;
    description: string;
    action?: { label: string; onClick: () => void };
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
    return (
        <div className={styles.root}>
            <div className={styles.title}>{title}</div>
            <div className={styles.description}>{description}</div>
            {action && (
                <button type="button" className={styles.action} onClick={action.onClick}>
                    {action.label}
                </button>
            )}
        </div>
    );
}
